<template>
  <div class="page">
    <div style="font-size: 25px;margin: 10px 0;">兑换商品积分比例: </div>
    <div style="padding-left: 100px">
      <div style="display: flex;align-items: center;font-size: 20px;">
        <el-input style="width: 100px;margin-right: 10px" v-model="form.point" placeholder="请输入"></el-input>
        积分等于
        <el-input style="width: 100px;margin:0 10px" v-model="form.amount" placeholder="请输入"></el-input>
        元
      </div>
      <div style="margin-top: 20px">
        <el-radio-group v-model="form.open">
          <el-radio :label="1">开 启</el-radio>
          <el-radio :label="0">关 闭</el-radio>
        </el-radio-group>
      </div>

    </div>
    <div style="font-size: 16px">
      <div style="margin: 10px 0">说明：此处设置的是 用户的积分在兑换商品时候的比例，而非用户加油的获取积分的比例。</div>
      <div>如：一个商品需要积分1000分，油站设置的比例为  10积分等于1分钱，用户兑换之后  加油站需要向平台进行支付 1元</div>
    </div>
    <el-button style="margin-left: 100px;margin-top: 20px;width: 150px;" @click="edit">提 交</el-button>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  seting_integral_goods,
  edit_setting
} from "@/api/integralMall";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      form:{
        open:1,
        point:'',
        amount:''
      }
    }
  },
  mounted() {
    this.getIfo()
  },
  methods:{
    async edit(){
      const res = await edit_setting({app_id:this.app_id,...this.form})
      if(res.code == 200){
        this.$message.success(res.msg)
        this.getIfo()
      }
    },
    async getIfo(){
      const res = await seting_integral_goods({app_id:this.app_id})
      console.log(res)
      let arr = Object.keys(this.form,res.data)
      console.log(arr)
      arr.forEach(e=>{
        this.form[e] = res.data[e]
      })
    },
  }
};
</script>

<style scoped>
.page{
  padding-left: 20px;
}
</style>